import tableOfContents from "../../../../../magnolia-component-library/assets/js/modules/tableOfContents";

export default function(el) {
    tableOfContents(el, "toc__link--active");
}
